/* eslint-disable  @typescript-eslint/no-explicit-any */

import React from 'react';
import { TextProps } from 'react-native';
import { Text } from '../Text';

export interface EmphasizedSubTextProps {
  children?: any;
  emphStyle?: unknown;
  separator?: string;
  text?: string;
}

export const EmphasizedSubText = ({
  children,
  emphStyle,
  separator = '**',
  style,
  text,
}: TextProps & EmphasizedSubTextProps): React.JSX.Element| null => {
  if (!text && !children) {
    return null;
  }

  const splitted = (text || children || '').split(separator);

  return (
    <Text style={style}>
      {splitted.map((portion, index) => {
        if (index % 2 === 0) {
          return portion;
        }

        return (
          <Text style={emphStyle} key={index}>
            {portion}
          </Text>
        );
      })}
    </Text>
  );
};
